export const PASSWORD_EXPIRED = 'PasswordExpired';
